import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css';
import Logo from '../../components/Logo/Logo';
import { useNavigate } from 'react-router-dom';
import { authLogin } from '../../api/auth';

const Login = () => {
  const navigate =useNavigate()
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const { email, password } = values;

    setLoading(true);
    try {
      const response = await authLogin(email, password);
      console.log('Response:', response);

      if (response?.token) {
        if (response?.user?.role === 'user') {
          message.error("Invalid Credentials");
        } else if (response?.user?.role === 'superAdmin') {
          localStorage.setItem('admintoken', response.token);
          message.success("Login successful");
          navigate("/dashboard");
        } else if (response?.user?.role === 'admin') {
          localStorage.setItem('admintoken', response.token);
          message.success("Login successful");
          navigate("/users");
        } else {
          message.error("Invalid role");
        }
      } else {
        message.error("Login failed.");
      }
    } catch (error) {
      message.error("An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' , backgroundColor: 'gray'}}>
      <div style={{ marginBottom: '20px', color: 'black', }}>
        <Logo />
      </div>

      <Form
        name="login_form"
        className="login-form  "
        initialValues={{ remember: true }}
        onFinish={onFinish} // Use Form's onFinish instead of button's onClick
        style={{ maxWidth: '340px', width: '100%' }}
      >
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your Email!', type: 'email' }]}
        >
          <Input prefix={<MailOutlined className="site-form-item-icon " />} placeholder="Email" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%' }} loading={loading}>
            Sign in
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
